var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"12","fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","d":"M12.1 7.25H7.55v4.475h-2.1V7.25H.9V5.275h4.55v-4.5h2.1v4.5h4.55z"}})])
}
var staticRenderFns = []

export default { render: render }